export const PANEL_ADVANCED_PROP = {
  ALIGNMENT: "alignment",
  ICON: "icon",
  HAS_ICON: "hasIcon",
  TITLE: "title",
  BORDER_RADIUS: "borderRadius",
  COLORS: "colors",
};
